import { useAuth0 } from "@auth0/auth0-react";
import { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TokenContext } from "../../constants/Contexts";
import { IApplication } from "../../interfaces/IApplication";
import { IServiceResponse } from "../../interfaces/IServiceReponse";
import ApplicationService from "../../services/ApplicationService";
import {
  getApplicationsError,
  getApplicationsStarted,
  getApplicationsSuccess,
} from "../../state/application/applicationActions";

const DownloadMiMComponent = () => {
  const accessToken = useContext(TokenContext);
  const dispatch = useDispatch();
  const [hubDownloadUrl, setHubDownloadUrl] = useState("");
  const { isAuthenticated } = useAuth0();
  const hubAppId = process.env.REACT_APP_HUB_APP_ID!;
  //Gets the latest version of the MiM Hub and sets the download link
  const getHubDownloadUrl = useCallback(async () => {
    if (accessToken) {
      dispatch(getApplicationsStarted());
      try {
        const applicationService = new ApplicationService(accessToken);
        const response = await applicationService.getApplications(
          hubAppId,
          "ascending",
          true
        );
        const serviceResponse: IServiceResponse = response.data;
        const applications: IApplication[] = serviceResponse.data;
        //Get the most up-to-date application release
        const hub: IApplication = applications.filter((x) => x.isLatest)[0];
        setHubDownloadUrl(hub.downloadURL);
        dispatch(getApplicationsSuccess(applications));
      } catch (error) {
        dispatch(getApplicationsError(error));
      }
    }
  }, [accessToken, dispatch, hubAppId]);

  useEffect(() => {
    if (isAuthenticated && accessToken) {
      getHubDownloadUrl();
    }
  }, [isAuthenticated, accessToken, getHubDownloadUrl]);

  return (
    <div
      id="download-mim"
      className="h-[80px] p-10 bg-grey-dark-2 flex flex-row items-center"
    >
      <a href={hubDownloadUrl} className="btn btn-primary">
        Download MiM
      </a>
    </div>
  );
};

export default DownloadMiMComponent;
